import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { Observable,  of as observableOf } from 'rxjs';
import { map } from 'rxjs/operators';

import { FeatureService, IFeatures } from '../../common/feature.service';

@Injectable()
export class FeatureGuard implements CanActivate {
  constructor(
    private featureService: FeatureService,
    private router: Router
  ) { }

  canActivate(route: ActivatedRouteSnapshot) {
    if (!route.data['feature']) return observableOf(true);
    return this.featureService.getMergedConfig().pipe(
      map((features: IFeatures) => {
        if (features[route.data['feature']['key']] !== route.data['feature']['state']) {
          this.router.navigate(['/']);
        }
        return true;
      }));
  }
}
